<template>
  <div class="Login">
    <div class="container">
      <div class="wrapper">
        <form @submit.prevent="login" action method="post" name="Login_Form" class="form-signin">
          <h3 class="form-signin-heading">要員募集</h3>
          <hr class="colorgraph">
          <br>
          <input
            type="text"
            class="form-control"
            name="userId"
            v-model="userId"
            placeholder="ユーザーID (メールアドレス)"
            required
            autofocus
          >
          <input
            type="password"
            class="form-control"
            name="password"
            v-model="password"
            placeholder="パスワード"
            required
          > 
          <button class="btn btn-lg btn-primary btn-block">ログイン</button>
          <br>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store.js'

export default {
  name: 'Login',
  data() {
    return {
      userId: '',
      password: ''
    }
  },
  methods: {
    login() {
      this.$cognito
        .login(this.userId, this.password)
        .then(result => {
          //console.log(sessionStorage.getItem('Authorization'))
          //this.$cognito.getCurrentUserIdToken()
          this.$cognito.getUserAttribute()
          this.$router.replace('/Menu')
        })
        .then(err => {
          this.error = err
        })
    }
  }
}
</script>

<style scoped >
.wrapper {
  margin-top: 80px;
  margin-bottom: 20px;
}

.form-signin {
  max-width: 420px;
  padding: 30px 38px 66px;
  margin: 0 auto;
  background-color: #eee;
  border: 3px dotted rgba(0, 0, 0, 0.1);
}

.form-signin-heading {
  text-align: center;
  margin-bottom: 30px;
}

.form-control {
  position: relative;
  font-size: 16px;
  height: auto;
  padding: 10px;
}

input[type="text"] {
  margin-bottom: 0px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

input[type="password"] {
  margin-bottom: 20px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}


</style>


// WEBPACK FOOTER //
// src/components/Login.vue